<template>
  <!-- 添加一个场景页面 -->
  <!-- 设置页面的内容区域 -->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <!-- 一个对象的详情设置页面---公共部分 -->
      <!-- 对象title -->
      <config-title-hang>
        <span slot="config_title_hang_ele2">对象参数设置</span>
        <span v-if="$route.query.pageType === 'control'" slot="config_title_hang_ele5"
          @click="goShangYiJiBtnHandle">上一级设置</span>
      </config-title-hang>
      <!-- 对象名称 -->
      <config-hang>
        <span slot="config_hang_ele2">对象名称</span>
        <!-- img和input 配套使用 点击可以触发input的聚焦事件  v-model实际上是直接绑定的仓库数据信息 -->
        <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
        <input type="text" slot="config_hang_input_right" id="xiugaiName" placeholder="请输入对象名称"
          v-model="ServeOneObjectinfo.remark" />
      </config-hang>
      <!-- 对象按钮图片 -->
      <config-hang @click.native="xuanImgBtnHandle">
        <span slot="config_hang_ele2">对象按钮图片</span>
        <img slot="config_hang_xuanimg" :src="computerObjectIconSrc" alt />
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <!-- 对象区域 -->
      <config-hang @click.native="xuanRegionBtnHandle">
        <span slot="config_hang_ele2">对象区域</span>
        <span slot="config_hang_ele3">{{ ServeOneObjectinfo.regionName }}</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <!-- 对象是是否显示 -->
      <config-hang :switchState="ServeOneObjectinfo.deleteState" @click.native="showifBtnHandle">
        <span slot="config_hang_ele2">对象是否显示</span>
        <img slot="config_hang_switchBtn_open" src="~assets/img/config/zhu_kai.png" alt />
        <img slot="config_hang_switchBtn_close" src="~assets/img/config/zhu_guan.png" alt />
      </config-hang>
      <!-- 以下是针对不同设备的设置 内容 -->
      <!-- 016  三合一八键环境面板 -->
      <div v-if="deviceObjectTypeJudge('016')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <config-hang @click.native="
          selectBindingObjectBtnHandle(
            '选择空调对象',
            '08',
            ServeOneObjectinfo.businessId1,
            'aircond'
          )
          ">
          <span slot="config_hang_ele2">选择绑定空调控制对象</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId1Desc
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="
          selectBindingObjectBtnHandle(
            '选择地暖对象',
            '017',
            ServeOneObjectinfo.businessId2,
            'floorheating'
          )
          ">
          <span slot="config_hang_ele2">选择绑定地暖控制对象</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId2Desc
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="
          selectBindingObjectBtnHandle(
            '选择新风对象',
            '018',
            ServeOneObjectinfo.businessId3,
            'newtrend'
          )
          ">
          <span slot="config_hang_ele2">选择绑定新风控制对象</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId3Desc
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="
          selectBindingObjectBtnHandle(
            '选择环境探测对象',
            '019',
            ServeOneObjectinfo.businessId4,
            'probe'
          )
          ">
          <span slot="config_hang_ele2">选择绑定环境探测对象</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId4Desc
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
      </div>
      <!--03 四键面板 09 8键面板 020 F键面板 -->
      <div v-else-if="deviceObjectTypeJudge('03', '09', '020')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <config-hang @click.native="selectControlTypeBtnHandle('控制类型选择')">
          <span slot="config_hang_ele2">控制类型选择</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.buttonName
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="selectControlObjectBtnHandle('控制对象选择')">
          <span slot="config_hang_ele2">控制对象选择</span>
          <span slot="config_hang_ele3">{{ computer03ShowStateText1 }} {{ computer03ShowStateText2 }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <config-hang @click.native="xaiZaiBtnHandle">
          <span slot="config_hang_ele_xia_zai">下载控制参数</span>
        </config-hang>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
      </div>
      <!--02 两路调光-->
      <div v-else-if="deviceObjectTypeJudge('02')"></div>
      <!--015 A0电机控制  06 A电机  010 丙申开合帘电机-->
      <div v-else-if="deviceObjectTypeJudge('015', '06', '010')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <config-hang inputID="xiugaiName1">
          <span slot="config_hang_ele2">电机地址</span>
          <img v-if="$route.query.pageType == 'configAdd'" slot="config_hang_xiugai" src="~assets/img/config/xiugai.png"
            alt />
          <!-- //代号20220312-1 -->
          <input type="text" slot="config_hang_input_right" id="xiugaiName1" placeholder="范围（1-254）"
            v-model.trim="ServeOneObjectinfo.deviceNo" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" :disabled="$route.query.pageType != 'configAdd'" />
        </config-hang>
        <!-- 如果A类设备对象是第一次添加  不显示下载接口，保存并返回按钮会进行下载，只有下载成功才能成功添加 -->
        <div v-if="$route.query.pageType != 'configAdd'">
          <config-hang @click.native="xaiZaiBtnHandle">
            <span slot="config_hang_ele_xia_zai">下载电机地址</span>
          </config-hang>
          <config-hang @click.native="dianjiFangXiang(0)">
            <span slot="config_hang_ele_xia_zai">电机默认转向</span>
          </config-hang>
          <config-hang @click.native="dianjiFangXiang(1)">
            <span slot="config_hang_ele_xia_zai">电机反向</span>
          </config-hang>
        </div>
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <div class="xiaotishi_style">
          小提示：请先确保电机处于接收电机地址的状态，否则可能无法添加或下载电机地址。
        </div>
      </div>

      <!--08 A空调控制 017 A地暖 018 A新风控制 -->
      <div v-else-if="deviceObjectTypeJudge('08', '017', '018')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <config-hang inputID="xiugaiName1">
          <span slot="config_hang_ele2">转接设备地址</span>
          <img v-if="$route.query.pageType == 'configAdd'" slot="config_hang_xiugai" src="~assets/img/config/xiugai.png"
            alt />
          <!-- //代号20220312-1 -->
          <input type="text" slot="config_hang_input_right" id="xiugaiName1" placeholder="范围（0-254）没有填0"
            v-model.trim="ServeOneObjectinfo.gatewayNo" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" :disabled="$route.query.pageType != 'configAdd'" />
        </config-hang>
        <config-hang inputID="xiugaiName2">
          <span slot="config_hang_ele2">受控设备地址或通道号</span>
          <img v-if="$route.query.pageType == 'configAdd'" slot="config_hang_xiugai" src="~assets/img/config/xiugai.png"
            alt />
          <!-- //代号20220312-1 -->
          <input type="text" slot="config_hang_input_right" id="xiugaiName2" placeholder="范围（1-65535）"
            v-model.trim="ServeOneObjectinfo.deviceNo" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" :disabled="$route.query.pageType != 'configAdd'" />
        </config-hang>
        <!-- 如果A类设备对象是第一次添加  不显示下载接口，保存并返回按钮会进行下载，只有下载成功才能成功添加 -->
        <div v-if="$route.query.pageType != 'configAdd'">
          <config-hang @click.native="xaiZaiBtnHandle">
            <span slot="config_hang_ele_xia_zai">下载控制参数</span>
          </config-hang>
        </div>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <div class="xiaotishi_style">
          小提示：请先确保受控设备处于接收地址的状态，否则可能无法添加或下载地址。
        </div>
      </div>
      <!-- 024 A音乐控制 -->
      <div v-else-if="deviceObjectTypeJudge('024')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <config-hang inputID="xiugaiName1">
          <span slot="config_hang_ele2">组ID</span>
          <img v-if="$route.query.pageType == 'configAdd'" slot="config_hang_xiugai" src="~assets/img/config/xiugai.png"
            alt />
          <!-- //代号20220312-1 -->
          <input type="text" slot="config_hang_input_right" id="xiugaiName1" placeholder="范围（0-254）没有填0"
            v-model.trim="ServeOneObjectinfo.gatewayNo" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" :disabled="$route.query.pageType != 'configAdd'" />
        </config-hang>
        <config-hang inputID="xiugaiName2">
          <span slot="config_hang_ele2">通道ID</span>
          <img v-if="$route.query.pageType == 'configAdd'" slot="config_hang_xiugai" src="~assets/img/config/xiugai.png"
            alt />
          <!-- //代号20220312-1 -->
          <input type="text" slot="config_hang_input_right" id="xiugaiName2" placeholder="范围（1-254）"
            v-model.trim="ServeOneObjectinfo.deviceNo" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" :disabled="$route.query.pageType != 'configAdd'" />
        </config-hang>
        <!-- 如果A类设备对象是第一次添加  不显示下载接口，保存并返回按钮会进行下载，只有下载成功才能成功添加 -->
        <div v-if="$route.query.pageType != 'configAdd'">
          <config-hang @click.native="xaiZaiBtnHandle">
            <span slot="config_hang_ele_xia_zai">下载控制参数</span>
          </config-hang>
        </div>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <div class="xiaotishi_style">
          小提示：请先确保受控设备处于接收地址的状态，否则可能无法添加或下载地址。
        </div>
      </div>

      <!-- 022 A定时控制 -->
      <div v-else-if="deviceObjectTypeJudge('022')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <config-hang v-if="$route.query.pageType != 'configAdd'" @click.native="timeConfig022BtnHandle">
          <span slot="config_hang_ele2">时间设置</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <config-hang :switchState="Number(ServeOneObjectinfo.businessId1)" @click.native="showif022BtnHandle">
          <span slot="config_hang_ele2">定时开关状态</span>
          <img slot="config_hang_switchBtn_open" src="~assets/img/config/zhu_kai.png" alt />
          <img slot="config_hang_switchBtn_close" src="~assets/img/config/zhu_guan.png" alt />
        </config-hang>

        <config-hang inputID="xiugaiName2">
          <span slot="config_hang_ele2">设置定时时间</span>
          <span slot="config_hang_ele_tishi">24小时制时间</span>
          <img slot="config_hang_xiugai" src="~assets/img/config/xiugai.png" alt />
          <!-- //代号20220312-1 -->
          <input type="text" slot="config_hang_input_right_hour" id="xiugaiName3" placeholder="小时"
            v-model.trim="serveHour" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" />
          <span slot="config_hang_ele_fenhao">:</span>
          <!-- //代号20220312-1 -->
          <input type="text" slot="config_hang_input_right_min" id="xiugaiName2" placeholder="分钟"
            v-model.trim="serveMin" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" />
        </config-hang>

        <config-hang @click.native="cycleConfig022Btnhandle">
          <span slot="config_hang_ele2">重复周期设置</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
          <!-- <span slot="config_hang_ele3">{{ServeOneObjectinfo.businessId3}}</span> -->
          <span slot="config_hang_022_ele3">{{ computerCycleConfigShow }}</span>
        </config-hang>

        <config-hang @click.native="selectOneScene022BtnHandle">
          <span slot="config_hang_ele2">定时触发的场景</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId4Desc
          }}</span>
        </config-hang>

        <!-- 如果A类设备对象是第一次添加  不显示下载接口，保存并返回按钮会进行下载，只有下载成功才能成功添加 -->
        <div v-if="$route.query.pageType != 'configAdd'">
          <config-hang @click.native="xaiZaiBtnHandle">
            <span slot="config_hang_ele_xia_zai">下载控制参数</span>
          </config-hang>
        </div>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <div class="xiaotishi_style">
          小提示：请先确保受控设备处于接收地址的状态，否则可能无法添加或下载地址。
        </div>
      </div>

      <!-- 07 门锁 -->
      <div v-else-if="deviceObjectTypeJudge('07')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <config-hang :switchState="Number(ServeOneObjectinfo.passwordState)" @click.native="passwordifBtnHandle">
          <span slot="config_hang_ele2">密码保护是否开启</span>
          <img slot="config_hang_switchBtn_open" src="~assets/img/config/zhu_kai.png" alt />
          <img slot="config_hang_switchBtn_close" src="~assets/img/config/zhu_guan.png" alt />
        </config-hang>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <!-- 05 07 013共用以下模块 -->
        <!-- 触发类型选择 -->
        <config-hang @click.native="selectControlTypeBtnHandle('触发类型选择')">
          <span slot="config_hang_ele2">触发类型选择</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.buttonName
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 开锁时选择的设备 -->
        <config-hang @click.native="
          selectControlObjectStateBtnHandle('控制对象及状态选择', 1)
          ">
          <span slot="config_hang_ele2">开锁时触发的对象及状态</span>
          <span slot="config_hang_ele3">
            {{ ServeOneObjectinfo.businessId1Desc }}
            {{ computer05ShowStateText1 }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 关锁时选择的设备 -->
        <config-hang @click.native="
          selectControlObjectStateBtnHandle('控制对象及状态选择', 2)
          ">
          <span slot="config_hang_ele2">关锁时触发的对象及状态</span>
          <span slot="config_hang_ele3">
            {{ ServeOneObjectinfo.businessId2Desc }}
            {{ computer05ShowStateText2 }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 下载按钮 -->
        <config-hang @click.native="xaiZaiBtnHandle">
          <span slot="config_hang_ele_xia_zai">下载控制参数</span>
        </config-hang>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <!-- <div class="xiaotishi_style">小提示：请先确保受控设备处于接收地址的状态，否则可能无法添加或下载地址。</div> -->
      </div>

      <!-- 013 安防控制-->
      <div v-else-if="deviceObjectTypeJudge('013')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <config-hang :switchState="Number(ServeOneObjectinfo.passwordState)" @click.native="passwordifBtnHandle">
          <span slot="config_hang_ele2">密码保护是否开启</span>
          <img slot="config_hang_switchBtn_open" src="~assets/img/config/zhu_kai.png" alt />
          <img slot="config_hang_switchBtn_close" src="~assets/img/config/zhu_guan.png" alt />
        </config-hang>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <!-- 05 07 013共用以下模块 -->
        <!-- 触发类型选择 -->
        <config-hang @click.native="selectControlTypeBtnHandle('触发类型选择')">
          <span slot="config_hang_ele2">触发类型选择</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.buttonName
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 布防时选择的设备 -->
        <config-hang @click.native="
          selectControlObjectStateBtnHandle('控制对象及状态选择', 1)
          ">
          <span slot="config_hang_ele2">布防时触发的对象及状态</span>
          <span slot="config_hang_ele3">
            {{ ServeOneObjectinfo.businessId1Desc }}
            {{ computer05ShowStateText1 }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 撤防时选择的设备 -->
        <config-hang @click.native="
          selectControlObjectStateBtnHandle('控制对象及状态选择', 2)
          ">
          <span slot="config_hang_ele2">撤防时触发的对象及状态</span>
          <span slot="config_hang_ele3">
            {{ ServeOneObjectinfo.businessId2Desc }}
            {{ computer05ShowStateText2 }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 下载按钮 -->
        <config-hang @click.native="xaiZaiBtnHandle">
          <span slot="config_hang_ele_xia_zai">下载控制参数</span>
        </config-hang>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <!-- <div class="xiaotishi_style">小提示：请先确保受控设备处于接收地址的状态，否则可能无法添加或下载地址。</div> -->
      </div>

      <!-- PRODUCT_27("027", "W1智能插座") -->
      <div v-else-if="deviceObjectTypeJudge('027')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <config-hang @click.native="cycleTask027ConfigBtnHandle">
          <span slot="config_hang_ele2">周期定时任务设置</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <config-hang @click.native="loopTask027ConfigBtnHandle">
          <span slot="config_hang_ele2">循环定时任务设置</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <config-hang @click.native="liShiDianLiang027BtnHandle">
          <span slot="config_hang_ele2">历史电量统计</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
      </div>

      <!-- 019 环境探测器 -->
      <div v-else-if="deviceObjectTypeJudge('019')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <config-hang @click.native="
          selectConfig019ObjectBtnHandle(
            '温度触发设置',
            ServeOneObjectinfo.businessId1,
            'temp'
          )
          ">
          <span slot="config_hang_ele2">温度触发设置</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId1Desc
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="
          selectConfig019ObjectBtnHandle(
            '湿度触发设置',
            ServeOneObjectinfo.businessId2,
            'humidity'
          )
          ">
          <span slot="config_hang_ele2">湿度触发设置</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId2Desc
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="
          selectConfig019ObjectBtnHandle(
            'PM25触发设置',
            ServeOneObjectinfo.businessId3,
            'PM25'
          )
          ">
          <span slot="config_hang_ele2">PM25触发设置</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId3Desc
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-hang @click.native="
          selectConfig019ObjectBtnHandle(
            'VOC触发设置',
            ServeOneObjectinfo.businessId4,
            'VOC'
          )
          ">
          <span slot="config_hang_ele2">VOC触发设置</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.businessId4Desc
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
      </div>

      <!--05  感应器   -->
      <div v-else-if="deviceObjectTypeJudge('05')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <!-- 05 07 013共用以下模块 -->
        <!-- 触发类型选择 -->
        <config-hang @click.native="selectControlTypeBtnHandle('触发类型选择')">
          <span slot="config_hang_ele2">触发类型选择</span>
          <span slot="config_hang_ele3">{{
            ServeOneObjectinfo.buttonName
          }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 有人时选择的设备 -->
        <config-hang @click.native="
          selectControlObjectStateBtnHandle('控制对象及状态选择', 1)
          ">
          <span slot="config_hang_ele2">有人时触发的对象及状态</span>
          <span slot="config_hang_ele3">
            {{ ServeOneObjectinfo.businessId1Desc }}
            {{ computer05ShowStateText1 }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 无人时选择的设备 -->
        <config-hang @click.native="
          selectControlObjectStateBtnHandle('控制对象及状态选择', 2)
          ">
          <span slot="config_hang_ele2">无人时触发的对象及状态</span>
          <span slot="config_hang_ele3">
            {{ ServeOneObjectinfo.businessId2Desc }}
            {{ computer05ShowStateText2 }}</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>
        <!-- 下载按钮 -->
        <config-hang @click.native="xaiZaiBtnHandle">
          <span slot="config_hang_ele_xia_zai">下载控制参数</span>
        </config-hang>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
      </div>

      <!-- PRODUCT_23("023", "F路影视控制"),  -->
      <div v-else-if="deviceObjectTypeJudge('023')">
        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>

        <config-hang v-if="$route.query.pageType != 'configAdd'" @click.native="learningConfig023BtnHandle">
          <span slot="config_hang_ele2">学习控制功能</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <config-hang v-if="$route.query.pageType != 'configAdd'" @click.native="changeConfig023ShowTextBtnHandle()">
          <span slot="config_hang_ele2">修改遥控自定义显示文字</span>
          <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
        </config-hang>

        <config-title-hang class="cofig_title_hang_height_device_object_detaile"></config-title-hang>
        <div class="xiaotishi_style">
          小提示:学习控制功能流程:1，点击 学习控制功能。2，弹出的页面，点击
          要学习的遥控按钮，按钮变色。设备指 示灯闪烁，10S
          内操作对应的遥控器对准设备学习位置，按下要学习的按钮。设备指示灯停止闪烁，学习成功。若不可用，可多操作几次。
        </div>
      </div>

      <div class="public_config_que_ren_btn" @click="saveReturnBtnHandle">
        保存并返回
      </div>
    </div>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
import { configPageDataRequest } from 'views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js'
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge
  // deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
export default {
  data() {
    return {
      ServeOneObjectinfo: {
        ////地址指向仓库
      },
      serveHour: '',
      serveMin: ''
    }
  },
  computed: {
    computerObjectIconSrc() {
      //计算选择区域图片应该显示的按钮
      console.log(this.ServeOneObjectinfo.iconUrl)
      if (this.ServeOneObjectinfo.iconUrl === '') {
        ///动态绑定图片 需要require
        return require('assets/img/config/xuanimg.png')
      } else {
        ////动态绑定http的url  不需要require
        return this.ServeOneObjectinfo.iconUrl
      }
    },
    computerCycleConfigShow() {
      let cycleShow = ''
      let count = 0
      if (this.ServeOneObjectinfo.businessId3.indexOf('1') != -1) {
        cycleShow += '周一 '
        count++
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf('2') != -1) {
        cycleShow += '周二 '
        count++
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf('3') != -1) {
        cycleShow += '周三 '
        count++
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf('4') != -1) {
        cycleShow += '周四 '
        count++
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf('5') != -1) {
        cycleShow += '周五 '
        count++
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf('6') != -1) {
        cycleShow += '周六 '
        count++
      }
      if (this.ServeOneObjectinfo.businessId3.indexOf('7') != -1) {
        cycleShow += '周日 '
        count++
      }
      if (count >= 7) {
        cycleShow = '每天'
      }
      return cycleShow
    },
    computer05ShowStateText1() {
      ///计算有人时回显状态

      if (this.ServeOneObjectinfo.businessId1 === '0') {
        ///说明是不绑定任何设备
        return ''
      } else if (this.ServeOneObjectinfo.businessId1 === '') {
        ///说明是没有进行过任何设置  清空回显
        this.ServeOneObjectinfo.businessId1Desc = ''
        return ''
      }

      if (this.ServeOneObjectinfo.buttonCode === '4') {
        ////  调光设备
        if (this.ServeOneObjectinfo.businessState1 === '') {
          return ''
        } else {
          return this.ServeOneObjectinfo.businessState1 + '%'
        }
      } else if (this.ServeOneObjectinfo.buttonCode === '3') {
        ////通断设备
        if (this.ServeOneObjectinfo.businessState1 === 1) {
          return '打开'
        } else if (this.ServeOneObjectinfo.businessState1 === 0) {
          return '关闭'
        } else return ''
      } else {
        return ''
      }
    },
    computer05ShowStateText2() {
      ///计算无人时回显状态

      if (this.ServeOneObjectinfo.businessId2 === '0') {
        ///说明是不绑定任何设备
        return ''
      } else if (this.ServeOneObjectinfo.businessId2 === '') {
        ///说明是没有进行过任何设置  清空回显
        this.ServeOneObjectinfo.businessId2Desc = ''
        return ''
      }

      if (this.ServeOneObjectinfo.buttonCode === '4') {
        ////  调光设备
        if (this.ServeOneObjectinfo.businessState2 === '') {
          return ''
        } else {
          return this.ServeOneObjectinfo.businessState2 + '%'
        }
      } else if (this.ServeOneObjectinfo.buttonCode === '3') {
        ////通断设备

        if (this.ServeOneObjectinfo.businessState2 === 1) {
          return '打开'
        } else if (this.ServeOneObjectinfo.businessState2 === 0) {
          return '关闭'
        } else return ''
      } else {
        return ''
      }
    },
    computer03ShowStateText1() {
      ///计算有人时回显状态
      if (this.ServeOneObjectinfo.businessId1 === '0') {
        ///说明是不绑定任何设备
        return '不绑定任何设备'
      } else if (this.ServeOneObjectinfo.businessId1 === '') {
        ///说明是没有进行过任何设置  清空回显
        return ''
      } else {
        return this.ServeOneObjectinfo.businessId1Desc
      }
    },
    computer03ShowStateText2() {
      ///计算有人时回显状态i
      if (this.ServeOneObjectinfo.buttonCode != '2') {
        ////如果不是双场景的类型
        return ''
      }
      if (
        this.ServeOneObjectinfo.businessId1 === '0' &&
        this.ServeOneObjectinfo.businessId2 === '0'
      ) {
        return ''
      } else if (this.ServeOneObjectinfo.businessId2 === '0') {
        ///说明是不绑定任何设备
        return '不绑定任何设备'
      } else if (this.ServeOneObjectinfo.businessId2 === '') {
        ///说明是没有进行过任何设置  清空回显
        return ''
      } else {
        return this.ServeOneObjectinfo.businessId2Desc
      }
    }
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    showifBtnHandle() {
      // 对象是否显示按钮按下了
      if (this.ServeOneObjectinfo.deleteState === 1) {
        this.ServeOneObjectinfo.deleteState = 0
      } else {
        this.ServeOneObjectinfo.deleteState = 1
      }
    },
    showif022BtnHandle() {
      //定时开关状态按下了
      if (Number(this.ServeOneObjectinfo.businessId1) === 1) {
        this.ServeOneObjectinfo.businessId1 = 0
      } else {
        this.ServeOneObjectinfo.businessId1 = 1
      }
    },
    xuanRegionBtnHandle() {
      // 选择区域的按钮按下了
      ///需要传递一个 区域的类型  要传入的参数类型  0:产品 1:场景 2:对象
      this.$router.push({ path: '/SelectRegion', query: { type: 2 } })
    },
    xuanImgBtnHandle() {
      // 选择img的按钮按下了
      ///需要传递一个 img类型列表  要传入图片的类型  0:产品 1:场景 2:对象
      this.$router.push({ path: '/SelectIcon', query: { type: 2 } })
    },
    saveReturnBtnHandle() {
      ////保存并返回按钮按下了  分两种情况 第一是 A类设备第一次添加  第二 不是A类设备的第一次添加
      if (!this.addAObjectJudge()) return ////基础信息的判断
      if (this.$route.query.pageType === 'configAdd') {
        /////入参处理  添加一个对象时的接口
        let tempData
        ////错误提示
        if (this.deviceObjectTypeJudge('06', '010', '015')) {
          if (!this.input06Judge()) return ////对用户输入的参数检查是否合法

          ////电机类型的入参
          tempData = {
            token: this.$store.state.token,
            productId: this.$route.query.productId,
            deviceNo: this.ServeOneObjectinfo.deviceNo, ///通道号  ////根据产品必填
            gatewayNo: '1', ////网关通道号  ///根据产品必填 //20220310-1 修复  新增 通道导致无法 与按键状态同步的问题
            regionId: this.ServeOneObjectinfo.regionId,
            remark: this.ServeOneObjectinfo.remark,
            iconId: this.ServeOneObjectinfo.iconId,
            deleteState: this.ServeOneObjectinfo.deleteState,

            businessId1: '', ///定时状态 --定时必填
            businessId2: '', ////定时时间---定时必填
            businessId3: '', ///重复设置 ---定时必填
            businessId4: '' ////定时触法场景id-定时必填
          }
        } else if (this.deviceObjectTypeJudge('08', '017', '018')) {
          ////空调地暖新风的添加
          if (!this.input08Judge()) return ////对用户输入的参数检查是否合法

          ////空调地暖新风类型的入参
          tempData = {
            token: this.$store.state.token,
            productId: this.$route.query.productId,
            deviceNo: this.ServeOneObjectinfo.deviceNo, ///通道号  ////根据产品必填
            gatewayNo: this.ServeOneObjectinfo.gatewayNo, ////网关通道号  ///根据产品必填
            regionId: this.ServeOneObjectinfo.regionId,
            remark: this.ServeOneObjectinfo.remark,
            iconId: this.ServeOneObjectinfo.iconId,
            deleteState: this.ServeOneObjectinfo.deleteState,

            businessId1: '', ///定时状态 --定时必填
            businessId2: '', ////定时时间---定时必填
            businessId3: '', ///重复设置 ---定时必填
            businessId4: '' ////定时触法场景id-定时必填
          }
        } else if (this.deviceObjectTypeJudge('024')) {
          ////入参判断处理  A音乐设备
          // console.log(typeof this.ServeOneObjectinfo.deviceNo);
          if (!this.input024Judge()) return ////对用户输入的参数检查是否合法
          /////处理一下入参  下载控制参数的入参
          tempData = {
            token: this.$store.state.token,
            productId: this.$route.query.productId,
            deviceNo: this.ServeOneObjectinfo.deviceNo, ///通道号  ////根据产品必填
            gatewayNo: this.ServeOneObjectinfo.gatewayNo, ////网关通道号  ///根据产品必填
            regionId: this.ServeOneObjectinfo.regionId,
            remark: this.ServeOneObjectinfo.remark,
            iconId: this.ServeOneObjectinfo.iconId,
            deleteState: this.ServeOneObjectinfo.deleteState,

            businessId1: '', ///定时状态 --定时必填
            businessId2: '', ////定时时间---定时必填
            businessId3: '', ///重复设置 ---定时必填
            businessId4: '' ////定时触法场景id-定时必填
          }
        } else if (this.deviceObjectTypeJudge('022')) {
          ////入参判断处理  A音乐设备
          // console.log(typeof this.ServeOneObjectinfo.deviceNo);
          if (!this.input022Judge()) return ////对用户输入的参数检查是否合法
          /////处理一下入参  下载控制参数的入参
          tempData = {
            token: this.$store.state.token,
            productId: this.$route.query.productId,
            deviceNo: '', ///通道号  ////根据产品必填
            gatewayNo: '', ////网关通道号  ///根据产品必填
            regionId: this.ServeOneObjectinfo.regionId,
            remark: this.ServeOneObjectinfo.remark,
            iconId: this.ServeOneObjectinfo.iconId,
            deleteState: this.ServeOneObjectinfo.deleteState,

            businessId1: this.ServeOneObjectinfo.businessId1, ///定时状态 --定时必填
            businessId2: this.ServeOneObjectinfo.businessId2, ////定时时间---定时必填
            businessId3: this.ServeOneObjectinfo.businessId3, ///重复设置 ---定时必填
            businessId4: this.ServeOneObjectinfo.businessId4 ////定时触法场景id-定时必填
          }
        }

        //添加A类设备(设置页面) 接口，获取数据
        this.$request({
          method: 'post',
          url: '/device/saveDeviceInfoByProductId',
          data: tempData
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTipsToast(3, res.data.message)
              ////说明信息填写错误,控制失败了，
              return
            } else {
              this.$router.go(-1)
              this.$showTipsToast(1, '添加成功', true) ////提示框
            }
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        //修改设备基本参数不交互底层 接口，获取数据
        this.$request({
          method: 'post',
          url: '/device/updateDeviceBasicsById',
          data: {
            token: this.$store.state.token,

            regionId: this.ServeOneObjectinfo.regionId,
            remark: this.ServeOneObjectinfo.remark,
            iconId: this.ServeOneObjectinfo.iconId,
            deviceId: this.ServeOneObjectinfo.deviceId,
            deleteState: this.ServeOneObjectinfo.deleteState
          }
        })
          .then(res => {
            if (res.data.code != 0) {
              this.$showTipsToast(3, res.data.message)
              ////说明信息填写错误,控制失败了，
              return
            } else {
              this.$router.go(-1)
              // this.$showTipsToast(1, "获取成功", true); ////提示框
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    goShangYiJiBtnHandle() {
      ///上一级设置按钮  被点击了

      ////、需要带进来productName 和productId 然后 跳转即可 //代号20220319-2
      this.$router.replace({
        path: 'deviceDetails',
        query: {
          title: this.$route.query.productName,
          productId: this.$route.query.productId
        }
      })
    },
    deviceObjectTypeJudge(...productCode) {
      ///判断是否是productCode类型设备  是返回 true
      return publicDeviceTypeJudge(
        this.$route.query.productCode,
        ...productCode
      )
    },
    selectBindingObjectBtnHandle(title, productCode, businessId, type) {
      /////环境探测设备的选择绑定一个对象按钮被点击了
      this.$router.push({
        path: 'selectBindingObject',
        query: {
          title: title,
          productCode: productCode,
          businessId: businessId,
          type: type
        }
      })
    },
    xaiZaiBtnHandle() {
      let tempData
      ////入参判断处理
      if (this.deviceObjectTypeJudge('06', '010', '015')) {
        // 电机设备
        console.log(typeof this.ServeOneObjectinfo.deviceNo)
        if (!this.input06Judge()) return ////对用户输入的参数检查是否合法

        /////处理一下入参  下载电机地址的入参
        tempData = {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId, ////要进行绑定参数的设备ID
          deviceNo: this.ServeOneObjectinfo.deviceNo, ///
          buttonCode: '', ///触发类型	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")
          gatewayNo: '',
          businessId1: '',
          businessId2: '',
          businessId3: '',
          businessId4: ''
        }
      } else if (this.deviceObjectTypeJudge('08', '017', '018')) {
        ////入参判断处理  空调地暖新风设备
        // console.log(typeof this.ServeOneObjectinfo.deviceNo);
        if (!this.input08Judge()) return ////对用户输入的参数检查是否合法
        /////处理一下入参  下载控制参数的入参
        tempData = {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId, ////要进行绑定参数的设备ID
          deviceNo: this.ServeOneObjectinfo.deviceNo, ///
          buttonCode: '', ///触发类型	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")
          gatewayNo: this.ServeOneObjectinfo.gatewayNo,
          businessId1: '',
          businessId2: '',
          businessId3: '',
          businessId4: ''
        }
      } else if (this.deviceObjectTypeJudge('024')) {
        ////入参判断处理  A音乐设备
        // console.log(typeof this.ServeOneObjectinfo.deviceNo);
        if (!this.input024Judge()) return ////对用户输入的参数检查是否合法
        /////处理一下入参  下载控制参数的入参
        tempData = {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId, ////要进行绑定参数的设备ID
          deviceNo: this.ServeOneObjectinfo.deviceNo, ///
          buttonCode: '', ///触发类型	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")
          gatewayNo: this.ServeOneObjectinfo.gatewayNo,
          businessId1: '',
          businessId2: '',
          businessId3: '',
          businessId4: ''
        }
      } else if (this.deviceObjectTypeJudge('022')) {
        ////入参判断处理  A定时设备
        // console.log(typeof this.ServeOneObjectinfo.deviceNo);
        if (!this.input022Judge()) return ////对用户输入的参数检查是否合法
        /////处理一下入参  下载控制参数的入参
        tempData = {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId, ////要进行绑定参数的设备ID  必填
          deviceNo: '', ///
          buttonCode: '', ///触发类型	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")
          gatewayNo: '',
          businessId1: this.ServeOneObjectinfo.businessId1,
          businessId2: this.ServeOneObjectinfo.businessId2,
          businessId3: this.ServeOneObjectinfo.businessId3,
          businessId4: this.ServeOneObjectinfo.businessId4
        }
      } else if (this.deviceObjectTypeJudge('03', '09', '020')) {
        ////入参判断处理  A定时设备
        // console.log(typeof this.ServeOneObjectinfo.deviceNo);
        if (!this.input03Judge()) return ////对用户输入的参数检查是否合法
        /////处理一下入参  下载控制参数的入参
        tempData = {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId, ////要进行绑定参数的设备ID  必填
          deviceNo: '', ///
          buttonId: this.ServeOneObjectinfo.buttonId, ///触发类型code	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")
          gatewayNo: '',
          businessId1: this.ServeOneObjectinfo.businessId1,
          businessId2: this.ServeOneObjectinfo.businessId2,
          businessId3: '',
          businessId4: ''
        }
      } else if (this.deviceObjectTypeJudge('05', '07', '013')) {
        ////入参判断处理  g感应器  门锁  安防
        // console.log(typeof this.ServeOneObjectinfo.deviceNo);
        if (!this.input05Judge()) return ////对用户输入的参数检查是否合法
        /////处理一下入参  下载控制参数的入参
        tempData = {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId, ////要进行绑定参数的设备ID  必填
          deviceNo: '', ///
          buttonId: this.ServeOneObjectinfo.buttonId, ///触发类型code	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")
          gatewayNo: '',
          businessId1: this.ServeOneObjectinfo.businessId1,
          businessState1: this.ServeOneObjectinfo.businessState1,
          businessId2: this.ServeOneObjectinfo.businessId2,
          businessState2: this.ServeOneObjectinfo.businessState2,
          businessId3: '',
          businessState3: '',
          businessId4: '',
          businessState4: ''
        }
      }
      console.log(tempData)

      /// 设置页面下发配置(通用) 接口
      configPageDataRequest(tempData)
        .then(res => {
          console.log(res)
          this.$showTipsToast(1, '下载成功', true) ////提示框
        })
        .catch(error => {
          console.log(error)
        })
    },
    input08Judge() {
      if (this.ServeOneObjectinfo.gatewayNo === '') {
        this.$toast('转接设备地址不能为空')
        return false
      } else {
        let attributeOne1 = Number(this.ServeOneObjectinfo.gatewayNo)
        if (attributeOne1 < 0 || attributeOne1 > 254) {
          console.log(typeof attributeOne1)
          this.$toast('转接设备地址范围1-254')
          return false
        }
      }
      if (this.ServeOneObjectinfo.deviceNo === '') {
        this.$toast('受控设备地址不能为空')
        return false
      } else {
        let attributeOne = Number(this.ServeOneObjectinfo.deviceNo)
        if (attributeOne < 0 || attributeOne > 65535) {
          console.log(typeof attributeOne)
          this.$toast('受控设备地址范围0-65535')
          return false
        }
      }
      return true
    },
    input024Judge() {
      if (this.ServeOneObjectinfo.gatewayNo === '') {
        this.$toast('组ID不能为空')
        return false
      } else {
        let attributeOne1 = Number(this.ServeOneObjectinfo.gatewayNo)
        if (attributeOne1 < 0 || attributeOne1 > 254) {
          console.log(typeof attributeOne1)
          this.$toast('组ID范围0-254')
          return false
        }
      }
      if (this.ServeOneObjectinfo.deviceNo === '') {
        this.$toast('通道ID不能为空')
        return false
      } else {
        let attributeOne = Number(this.ServeOneObjectinfo.deviceNo)
        if (attributeOne < 1 || attributeOne > 254) {
          console.log(typeof attributeOne)
          this.$toast('通道ID范围1-254')
          return false
        }
      }
      return true
    },
    input06Judge() {
      if (this.ServeOneObjectinfo.deviceNo === '') {
        this.$toast('电机地址不能为空')
        return false
      } else {
        let attributeOne = Number(this.ServeOneObjectinfo.deviceNo)
        if (attributeOne < 1 || attributeOne > 254) {
          console.log(typeof attributeOne)
          this.$toast('电机地址范围1-254')
          return false
        }
      }
      return true
    },
    input022Judge() {
      if (this.ServeOneObjectinfo.businessId1 === '') {
        this.$toast('开关状态不能为空！')
        return false
      } else if (this.serveHour === '' || this.serveMin === '') {
        this.$toast('定时时间不能为空！')
        return false
      } else if (
        Number(this.serveHour) < 0 ||
        Number(this.serveHour) > 23 ||
        Number(this.serveMin) < 0 ||
        Number(this.serveMin) > 59
      ) {
        console.log(typeof this.serveHour)
        this.$toast('定时时间格式不正确！')
        return false
      } else if (this.ServeOneObjectinfo.businessId3 === '') {
        this.$toast('重复周期不能为空！')
        return false
      } else if (
        this.ServeOneObjectinfo.businessId4 === '' ||
        this.ServeOneObjectinfo.businessId4Desc === ''
      ) {
        this.$toast('请选择触发场景！')
        return false
      }
      return true
    },
    input03Judge() {
      if (this.ServeOneObjectinfo.buttonId === 0) {
        this.$toast('控制类型不能为空！')
        return false
      } else if (
        this.ServeOneObjectinfo.businessId1 === '' &&
        this.ServeOneObjectinfo.businessId2 === ''
      ) {
        this.$toast('控制对象不能为空！')
        return false
      }
      return true
    },
    input05Judge() {
      if (this.ServeOneObjectinfo.buttonId === 0) {
        this.$toast('控制类型不能为空！')
        return false
      } else if (this.ServeOneObjectinfo.businessId1 === '') {
        this.$toast('第一个控制对象不能为空！')
        return false
      } else if (this.ServeOneObjectinfo.businessId2 === '') {
        this.$toast('第二个控制对象不能为空！')
        return false
      }

      return true
    },
    addAObjectJudge() {
      if (this.ServeOneObjectinfo.remark === '') {
        this.$toast('请输入对象名称！')
        return false
      } else if (this.ServeOneObjectinfo.iconId === '') {
        this.$toast('请选择按钮图片！')
        return false
      } else if (this.ServeOneObjectinfo.regionId === '') {
        this.$toast('请选择区域！')
        return false
      } else if (this.ServeOneObjectinfo.deleteState === '') {
        this.$toast('请确定显示状态！')
        return false
      }
      return true
    },
    dianjiFangXiang(direction) {
      ///设置电机方向 接口，获取数据
      this.$request({
        method: 'post',
        url: '/device/updateElectricDirection',
        data: {
          token: this.$store.state.token,
          productId: this.$route.query.productId,
          deviceNo: this.ServeOneObjectinfo.deviceNo,
          direction: direction ///0默认方向   1反方向
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data; ////拿到服务器返回的数据结果
            this.$showTipsToast(1, '下载成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    timeConfig022BtnHandle() {
      this.$router.push('timeConfig022Page')
    },
    cycleConfig022Btnhandle() {
      // this.$router.push("cycleConfig022Page");
      this.$router.push({ path: 'cycleConfig022Page', query: { type: '022' } })
    },
    selectOneScene022BtnHandle() {
      this.$router.push({
        path: 'selectOneScene',
        query: { type: '022config', title: '选择一个场景' }
      })
    },
    passwordifBtnHandle() {
      this.$showTipsToast(13, this.ServeOneObjectinfo)
    },
    cycleTask027ConfigBtnHandle() {
      ////周期定时任务按钮按下了
      // console.log("11111")
      this.$router.push('cycleTask027Config')
    },
    loopTask027ConfigBtnHandle() {
      ////循环定时任务按钮按下了

      ///获取插座循环定时信息 接口，获取数据
      this.$request({
        method: 'post',
        url: '/device/findLoopTimeById',
        data: {
          token: this.$store.state.token,
          deviceId: this.ServeOneObjectinfo.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data ////拿到服务器返回的数据结果
            console.log(res.data.data)
            this.$store.dispatch(
              'asyUpdataserveOneLoopTask027Data',
              res.data.data
            ) ///异步提交信息到仓库
            this.$router.push('changeLoopTask')

            // this.$showTipsToast(1, '下载成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    liShiDianLiang027BtnHandle() {
      ////历史电量统计按钮按下了
      console.log('历史电量按钮被点击了')
      this.$router.push({
        path: 'HistoricalElectricity027Page',
        query: {
          deviceId: this.ServeOneObjectinfo.deviceId
        }
      })
    },
    selectControlTypeBtnHandle(title) {
      console.log('1111122')
      this.$router.push({
        path: 'select03ControlType',
        query: { title: title }
      })
    },

    selectControlObjectBtnHandle(title) {
      if (this.ServeOneObjectinfo.buttonId === 0) {
        this.$toast('请先选择控制类型！')
        return
      }
      // console.log('1111122')
      this.$router.push({
        path: 'select03ControlObject',
        query: { title: title }
      })
    },
    selectConfig019ObjectBtnHandle(title, businessId, type) {
      /////环境探测设备的设置按钮被点击了

      ///获取环境探测通道详情 接口，获取数据
      this.$request({
        method: 'post',
        url: '/device/findDeviceTriggerById',
        data: {
          token: this.$store.state.token,
          triggerId: businessId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data ////拿到服务器返回的数据结果
            console.log(res.data.data)
            this.$store.dispatch('asyUpdataconfig019PageData', res.data.data) ///异步提交信息到仓库
            // 跳转页面
            this.$router.push({
              path: 'config019Page',
              query: {
                title: title,
                businessId: businessId,
                type: type
              }
            })
            // this.$showTipsToast(1, '下载成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    learningConfig023BtnHandle() {
      //x学习控制功能被按下了
      console.log(this.ServeOneObjectinfo)
      this.$showControlToast('paraconfig', this.ServeOneObjectinfo)
    },
    changeConfig023ShowTextBtnHandle() {
      this.$router.push({
        path: 'config023Page',
        query: { deviceId: this.ServeOneObjectinfo.deviceId }
      })
    },
    selectControlObjectStateBtnHandle(title, type) {
      if (this.ServeOneObjectinfo.buttonId === 0) {
        this.$toast('请先选择控制类型！')
        return
      }
      // console.log('1111122')
      this.$router.push({
        path: 'select05ControlObjectState',
        query: { title: title, type: type }
      })
    }
  },
  watch: {
    ////实时监测用户输入的时间是否合法
    serveHour(val) {
      console.log(val + typeof val)
      if (Number(val) < 0) {
        this.serveHour = 0
      } else if (Number(val) > 23) {
        this.serveHour = 23
      } else {
        this.serveHour = Number(val)
      }
      this.ServeOneObjectinfo.businessId2 = this.serveHour + ':' + this.serveMin
      console.log(this.ServeOneObjectinfo.businessId2)
    },
    ////实时监测用户输入的时间是否合法
    serveMin(val) {
      console.log(val + typeof val)
      if (Number(val) < 0) {
        this.serveMin = '0'
      } else if (Number(val) > 59) {
        this.serveMin = '59'
      } else {
        this.serveMin = Number(val)
      }

      this.ServeOneObjectinfo.businessId2 = this.serveHour + ':' + this.serveMin
      console.log(this.ServeOneObjectinfo.businessId2)
    }
  },
  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo ////一个对象的地址信息拿过来
    console.log(this.ServeOneObjectinfo)
    if (this.deviceObjectTypeJudge('022')) {
      ////补BUG20200511 解决businessId2 不合法时 用match解析错误的BUG
      ///定时设备对象需要处理
      console.log(this.ServeOneObjectinfo.businessId2)
      if (this.ServeOneObjectinfo.businessId2.indexOf(":") != -1) { ///说明包含：这个字符串
        ///处理拿到的时间
        this.serveHour = this.ServeOneObjectinfo.businessId2.match(/(\S*):/)[1] ////拿到时间之后  取出：之前的小时 取字符串
        this.serveMin = this.ServeOneObjectinfo.businessId2.match(/:(\S*)/)[1] ////拿到时间之后  取出：之后的分钟 取字符串
      } else {
        ///说明字符串是不合法的
        console.log("定时时间字符串不合法")
        this.serveHour = "" ////拿到时间之后  取出：之前的小时 取字符串
        this.serveMin = "" ////拿到时间之后  取出：之后的分钟 取字符串
      }
      if (this.ServeOneObjectinfo.businessId1 === '') {
        ///需要把定时时间的开关状态置位一下
        this.ServeOneObjectinfo.businessId1 = '1'
      }
      console.log(this.ServeOneObjectinfo)
    }
  }
}

/**
 *
 *    此页面进入之前1，得到 asyUpdataServeOneObjectinfo这个数据提交到仓库  2，传参跳页面  如下举例
 *       // 获取设备详情 接口，获取数据
      this.$request({
        method: "post",
        url: "/device/findDeviceById",
        data: {
          token: this.$store.state.token,
          deviceId: deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了 数据地址存到仓库
            this.$store.dispatch("asyUpdataServeOneObjectinfo", res.data.data); ///异步提交对象信息地址到仓库

            // 进入下一个页面
            this.$router.push({
              path: "deviceObjectDetails",
              query: {
                title: title,
                deviceId: deviceId,
                productCode: productCode
              }
            });
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
 */
</script>

<style></style>
